import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import StickyHeader from "../components/StickyHeader";
import StickyFooter from "../components/StickyFooter";
import "../../src/css/CompanyPage.css";

function CompanyPage() {
  // 轮播图状态
  const [currentSlide, setCurrentSlide] = useState(0);

  // 轮播图数据
  const slides = [
    {
      text: "用 户 侧 储 能 解 决 方 案 领 军 专 家",
      image: `${process.env.PUBLIC_URL}/imgs/banner.png`,
    },
    {
      text: "用 户 侧 储 能 解 决 方 案 领 军 专 家",
      image: `${process.env.PUBLIC_URL}/imgs/banner3.png`
    },
    {
      text: "用 户 侧 储 能 解 决 方 案 领 军 专 家",
      image: `${process.env.PUBLIC_URL}/imgs/banner2.png`
    },
  ];

  // 自动轮播
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
    // 动态导入AOS以确保在客户端加载
    const initAOS = async () => {
      try {
        const AOS = (await import("aos")).default;
        import("aos/dist/aos.css");

        // 延迟初始化以确保DOM完全加载
        setTimeout(() => {
          AOS.init({
            duration: 1000,
            once: true,
            easing: "ease-in-out", 
            offset: 100, // 提前100px触发
            delay: 0,
          });

          // 刷新AOS以确保初始可见元素也有动画
          AOS.refresh();
        }, 100);
      } catch (error) {
        console.warn("AOS failed to load", error);
      }
    };

    // 只在客户端初始化AOS
    if (typeof window !== "undefined") {
      initAOS();
    }

    // 清理函数
    return () => {
      // 如果需要，可以在这里清理AOS
      if (window.AOS) {
        window.AOS.refreshHard();
      }
    };
  }, []);

  // 手动切换幻灯片
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <StickyHeader />
      <div
        style={{
          flex: "1 0 auto",
          width: "100%",
        }}
      >
        {/* 公司简介banner - 轮播图版本 */}
        <div className="top-title-carousel" data-aos="fade-up">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-slide ${
                index === currentSlide ? "active" : ""
              }`}
              style={{
                backgroundImage: `url("${slide.image}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="carousel-text">{slide.text}</div>
            </div>
          ))}
          {/* 轮播图指示器 */}
          {slides.length > 1 && (
            <div className="carousel-indicators">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => goToSlide(index)}
                ></span>
              ))}
            </div>
          )}                                          
        </div>

        {/* 公 司 介 绍 */}
        <div>
          <Container>
            <div className="profile-content" data-aos="fade-down">
              <div className="profile-title">公 司 介 绍</div>
              <p>
                <img
                  src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                  alt=""
                  style={{
                    width: "90px",
                  }}
                  className="dot-animation"
                />
              </p>
            </div>

            <div className="content-box1" data-aos="fade-up">
              <div className="content-box1-left">
                <div className="box-title">公司简介</div>
                {/* <div className="box1-content">
                  公司聘请中国科学技术大学顶尖研发团队，建设国内一流的储能研发中心，形成BMS、PCS、EMS、储能系统集成等核心技术的自主研发能力，构建了从储能电站投资和开发、产品开发、设备制造到施工运维的全产业链服务体系。公司累计获得40余项发明/实用新型专利，先后荣获国家级高新技术企业、安徽省“专精特新”企业、省级绿色工厂等资质认证。
                </div> */}
                <ui className="box1-content">
                  <li>安徽合利电气股份有限公司（股票代码:873560），成立于2005年。</li>
                  <li>国家级高新技术企业，省级专精特新企业，省级绿色工厂，AAA级信用企业。</li>
                  <li>专业从事储能电站的投资、开发，储能集成系统的研发、制造；输配电设备的研发、制造。</li>
                  <li>聘请中国科学技术大学顶尖研发团队，建设国内一流的储能研发中心。</li>
                  <li>致力于成为用户侧储能解决方案领军专家，向分布式柔性能源终极梦想迈进！</li>
                </ui>
               
              </div>
              <img
                src={`${process.env.PUBLIC_URL}/imgs/lou.png`}
                alt=""
                style={{
                  width: "40%",
                  marginTop: "145px",
                }}
                className="content-box1-right"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
            </div>

            <div className="content-box2" data-aos="fade-up">
  <div className="box-title2">发展进程</div>
  <div 
    className="content-img"
    style={{ minHeight: "calc(100% + 20px)" }} // 增加20px高度
  >
    <img
      src={`${process.env.PUBLIC_URL}/imgs/cover63.png`}
      alt=""
      style={{
        width: "100%",
      }}
      data-aos="fade-up"
    />
    {[
      {
        title: "创业伊始",
        items: ["公司成立"],
        delay: "0",
        top: "19%",
        left: "0%",
        width: "120px", 
      },
      {
        title: "市场认可",
        items: ["登录新三板（股票代码 873560）", "转入创新层"],
        delay: "100",
        top: "68%",
        left: "2%",
        
      },
      {
        title: "科技兴企",
        items: ["荣获“国家高新技术企业”认定"],
        delay: "200",
        top: "19%",
        left: "18%",
      },
      {
        title: "技术储备",
        items: [
          "荣获“专精特新企业”认定",
          "荣获“绿色工厂”认定",
          "取得“储能设备远程管控平台”、“控制系统UI交互软件”、AI参数调优系统等12项发明专利以及23项实用新型专利",
        ],
        delay: "300",
        top: "68%",
        left: "35%",
        width: "260px", 
      },
      {
        title: "聚才拓进",
        items: [
          "聘请中科大顶尖团队，成立研发中心",
          "发布Enersafe Block 215、Enersafe Block 263模块化储能集成系统",
          "自研Nwa-S储能电站智慧管理平台",
          "开展用户侧储能电站投资、开发业务",
        ],
        delay: "300",
        top: "6%",
        left: "52%",
        width: "280px", 
      },
      {
        title: "奋楫争先",
        items: ["用户侧储能电站项目持续签约落地"],
        delay: "300",
        top: "68%",
        left: "70%",
        
      },
      {
        title: "赓续前行",
        items: [
          "机柜获取CMA、CANS、ilac-MRA型式检验认证报告",
          "取得虚拟电厂调度软件和智慧能源管控平台软著",
          "自持电站超100MWh+，累计服务客户数超80家",
          
        ],
        delay: "300",
        top: "7%",
        left: "80%",
        width: "250px", 

      },
    ].map((box, index) => (
      <div
        className={`content-box2-item ${
          index === 5 ? "half-width" : "full-width"
        }`}
        key={index}
        style={{ 
          top: box.top, 
          left: box.left,
          width: box.width || "auto",
          maxWidth: box.width || "none", 
        }}
      >
        <div className="item-title">{box.title}</div>
        <ul>
          {box.items.map((item, i) => (
            <li key={i} style={{ marginBottom: "10px" }}>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
</div>

            <div className="content-box3 d-flex" data-aos="fade-up">
              <div
                className="box-title"
                style={{ left: "20px", position: "absolute", top: "0" }}
              >
                运营运维能力
              </div>

              {/* 运营运维能力板块 */}
              {[
                {
                  bg: "#0059B0",
                  title: ["生产建议", "优化"],
                  items: [
                    "结合本地峰平谷电价时段、现场变压器配置和负载率、业主用电负荷实际数据及夏季高峰电网限电政策，依据储能电站自身消纳能力，提供生产安排、工序排班等优化建议",
                  ],
                  delay: "0",
                },
                {
                  bg: "#3F85CA",
                  title: ["储能电站安全", "管理"],
                  items: [
                    "巡检维护工作及记录台账",
                    "故障消缺工作及记录台账、安全设施检查工作及记录",
                    "组织日常技术、安全培训",
                    "极端异常、紧急故障恢复工作及记录",
                  ],
                  delay: "100",
                },
                {
                  bg: "#84B5E4",
                  title: ["检修维护", "工作"],
                  items: [
                    "重点季节维护计划、维护记录",
                    "电池绝缘检测",
                  ],
                  delay: "200",
                },
                {
                  bg: "#B8CFE7",
                  title: ["其他管理"],
                  items: [
                    "非运维方供货的设备维护协调工作",
                    "其他需要配合甲方协调管理的工作",
                  ],
                  delay: "300",
                },
              ].map((box, index) => (
                <div
                  className="box4-content flex-fill"
                  style={{ background: box.bg, width: "25%" }}
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={box.delay}
                >
                  <h3 style={{ fontWeight: "bold" }}>{box.title[0]}</h3>
                  {box.title[1] && (
                    <h3 style={{ fontWeight: "bold" }}>{box.title[1]}</h3>
                  )}

                  <div
                    style={{
                      marginTop: box.title.length > 1 ? "50px" : "90px",
                    }}
                  >
                    {box.items.map((item, i) => (
                      <li key={i} style={{ marginBottom: "10px" }}>
                        <span>{item}</span>
                      </li>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>

        {/* 技术优势 */}
        <div className="block2">
          <Container>
            <div className="top">
              <div className="noe1" data-aos="fade-down">
                <span className="h1">技 术 优 势</span>
                <p>
                  <img
                    src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                    alt=""
                    className="dot-animation"
                  />
                </p>
              </div>
              <div className="boxno">
                <div
                  className="linebut"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{ width: "85%" }}
                >
                  {[
                    { img: "cover34.png", text: "基于知识图谱AI的柔性EMS" },
                    {
                      img: "cover12.png",
                      text: "PACK级主动均衡技术(AET In packing)",
                    },
                    {
                      img: "cover13.png",
                      text: "逆卡诺循环低功耗热管理技术(LLTM-ICC)(国内首创)",
                    },
                    {
                      img: "cover44.png",
                      text: "热失控早期预警技术(国内首创)",
                    },
                  ].map((item, index) => (
                    <div
                      className="linebox"
                      key={index}
                      data-aos="zoom-in"
                      data-aos-delay={index * 200}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/${item.img}`}
                        alt=""
                      />
                      <p style={{ width: "180%" }}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        </div>

        {/* 智慧能源管控云平台 */}
        <div className="block3">
          <Container>
            <div className="box">
              <div className="top">
                <div className="noe1" data-aos="fade-down">
                  <span className="h1">智 慧 能 源 管 控 云 平 台</span>
                  <p>
                    <img
                      src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                      alt=""
                      className="dot-animation"
                    />
                  </p>
                </div>
                <div className="boxno">
                  <div
                    className="lef"
                    data-aos="fade-right"
                    style={{ textAlign: "left" }}
                  >
                    <h3 className="h32">智慧能源管控云平台</h3>
                    <li style={{ color: "#656464", fontSize: "20px" }}>
                      云平台让储能电站拥有决策判断和智能分析的智慧，让储能电站真正实现发电、储电、用电、管电、省电、售电的全周期管理。
                    </li>
                    <li style={{ color: "#656464", fontSize: "20px" }}>
                      作为储能电站的储能系统控制中枢，实现储能系统运行策略控制运行数据的存储，历史大数据分析及统计报表的输出。
                    </li>
                  </div>
                  <div
                    className="rits"
                    data-aos="fade-left"
                    data-aos-delay="400"
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/imgs/webPage.png`}
                      alt=""
                      className="image-hover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <div className="skipBlock">
        <Container>
          <div>
            <div className="h1-title">智慧能源管控平台</div>
            <div className="h2-title">智能分析&nbsp;&nbsp;&nbsp;&nbsp;调动中枢</div>
            <div>实时监控&nbsp;•&nbsp;智能策略&nbsp;•&nbsp;远程运维</div>
            <div>让能效管理更高效、更可靠</div>
            <div className="btn" onClick={() => { window.open('https://www.hellipower.com/login', '_blank') }}>进入EMS管控平台</div>
          </div>
        </Container>
      </div>

      <StickyFooter />
    </div>
  );
}

export default CompanyPage;
